/*
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-04-10, 12:18:00
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-04-10, 12:49:49
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API, API_URL } from '@/config';
import { togglePendingStoreActions, handleErrorResponses } from '@/utils/decorators';

import {
  TOGGLE_FORM_SENDING_STATUS,
} from './mutation-types';

export default {
  @togglePendingStoreActions()
  @handleErrorResponses()
  async sendComplainsForm({ commit, state }, data) {
    await API.post(`${API_URL}/mails`, data);
    commit(TOGGLE_FORM_SENDING_STATUS);
  },

  resetComplainsForm({ commit }) {
    commit(TOGGLE_FORM_SENDING_STATUS);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Complains/actions.js